import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 8h-14","key":"svg-0"}],["path",{"d":"M5 12h7","key":"svg-1"}],["path",{"d":"M12 16h-7","key":"svg-2"}],["path",{"d":"M16 14l4 4","key":"svg-3"}],["path",{"d":"M20 14l-4 4","key":"svg-4"}]]

const IconPlaylistX = createReactComponent('outline', 'playlist-x', 'PlaylistX', __iconNode);

export default IconPlaylistX;